import {
  Paragraph,
  TextRun,
} from "docx"

export const renderCourseworkSection = courseworkExperiences => {
  if (!courseworkExperiences || courseworkExperiences.length === 0) {
    return []
  }

  return [
    new Paragraph({
      children: [
        new TextRun({
          text: "COURSEWORK",
          bold: true,
          size: 21,
        }),
      ],
      spacing: {
        before: 200,
      },
      border: {
        bottom: {
          color: "#d3d3d3",
          space: 1,
          style: "single",
          size: 6,
        },
      },
    }),
    ...courseworkExperiences
      .map(experience => {
        const {
          title = "COURSE TITLE",
          school = "SCHOOL",
          bulletPoints = [],
        } = experience

        return [
          new Paragraph({
            spacing: {
              before: 50,
            },
            children: [
              new TextRun({
                text: title,
                bold: true,
                size: 21,
              }),
            ],
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: school,
                size: 20,
              }),
            ],
          }),
          ...bulletPoints.map(bulletPoint =>
            new Paragraph({
              bullet: {
                level: 0,
              },
              children: [
                new TextRun({
                  text: bulletPoint,
                  font: "cambria",
                  size: 20,
                }),
              ],
            })
          )
        ]
      })
      .flat(),
  ]
}
